import { useRoute } from 'vue-router/composables'
import { asyncTrack } from '@/track'
import { useHistoryStore } from '@/stores'

export function useBookExposure() {
  const route = useRoute()

  const bookExposure = function (bookInfo: any) {
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage
    asyncTrack('biz_listImp', {
      ...bookInfo,
      title: route.meta?.title,
      host: window.location.origin,
      url: window.location.href,
      route_title: prevPage?.route_title,
      route_host: prevPage?.route_host,
      route_url: prevPage?.route_url,
    })
  }

  return {
    bookExposure,
  }
}
